import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Tours from './pages/Tours';
import Checkout from './pages/Checkout';
import Restaurante from './pages/Restaurante';
import VentaTonelada from './pages/VentaTonelada';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTours from './pages/admin/AdminTours';
import AdminVentas from './pages/admin/AdminVentas';
import AdminEntregas from './pages/admin/AdminEntregas';
import AdminProductos from './pages/admin/AdminProductos';
import AdminPromociones from './pages/admin/AdminPromociones';
import AdminCafeVerde from './pages/admin/AdminCafeVerde';
import AdminCorreos from './pages/admin/AdminCorreos';
import AdminRoute from './components/AdminRoute';
import './App.css';

// Componente para layout condicional
const AppLayout = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isAdminLogin = location.pathname === '/admin/login';

  return (
    <div className="app">
      {/* Solo mostrar Navbar en rutas NO admin */}
      {!isAdminRoute && <Navbar />}
      
      <main className={isAdminRoute ? 'admin-main' : 'main-content'}>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/restaurante" element={<Restaurante />} />
          <Route path="/venta-tonelada" element={<VentaTonelada />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/ventas" element={<AdminRoute><AdminVentas /></AdminRoute>} />
          <Route path="/admin/productos" element={<AdminRoute><AdminProductos /></AdminRoute>} />
          <Route path="/admin/tours" element={<AdminRoute><AdminTours /></AdminRoute>} />
          <Route path="/admin/entregas" element={<AdminRoute><AdminEntregas /></AdminRoute>} />
          <Route path="/admin/promociones" element={<AdminRoute><AdminPromociones /></AdminRoute>} />
          <Route path="/admin/cafe-verde" element={<AdminRoute><AdminCafeVerde /></AdminRoute>} />
          <Route path="/admin/correos" element={<AdminRoute><AdminCorreos /></AdminRoute>} />
        </Routes>
      </main>

      {/* Solo mostrar Footer en rutas NO admin */}
      {!isAdminRoute && <Footer />}
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <Router>
            <AppLayout />
          </Router>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;